module.exports = __webpack_public_path__ + "img/expovina-primavera_08.4f243094.jpg";